// extracted by mini-css-extract-plugin
module.exports = {"container":"selector_container__r2gcN","header":"selector_header__xM0hn","finalSale":"selector_finalSale__wcCVF","footer":"selector_footer__rojaV"};